import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import ObjectiveCheckIn from "../Components/ObjectiveCheckIn";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faPencilAlt,
  faTimes,
  faTimesCircle,
  faTrash,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import "./ObjectiveDetails.css";

function ObjectiveDetails() {
  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [objectiveUserId, setObjectiveUserId] = useState("");
  const [weight, setWeight] = useState(0);
  const [status, setStatus] = useState("");
  const [dueDate, setDueDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [bossObjective, setBossObjective] = useState("");
  const [approverId, setApproverId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [level, setLevel] = useState(0);
  const [lastCheckIns, setLastCheckIns] = useState([]);
  const [checkinStatus, setCheckinStatus] = useState("on-track");
  const [note, setNote] = useState("");
  const [show, setShow] = useState(false);
  const [showAlt, setShowAlt] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [reportedCheckInLevel, setReportedCheckInLevel] = useState(0);
  const [reportedCheckInDate, setReportedCheckInDate] = useState(new Date());
  const [reportedCheckInId, setReportedCheckInId] = useState("");
  const [validatedCheckInLevel, setValidatedCheckInLevel] = useState(0);
  const [validatedCheckInNote, setValidatedCheckInNote] = useState("");
  const [file, setFile] = useState({});

  const handleLevelChange = (e) => {
    setLevel(e.target.value);
  };

  const { state } = useContext(AuthContext);

  const { oid } = useParams();

  const dayjs = require("dayjs");

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/${oid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.objective.description);
      setObjectiveUserId(response.data.objective.userId);
      setWeight(response.data.objective.weight);
      setDueDate(new Date(response.data.objective.dueDate));
      setStartDate(new Date(response.data.objective.created_at));
      setStatus(response.data.objective.status);
      setApproverId(response.data.objective.approverId);
      setId(response.data.objective._id);
      setBossObjective(response.data.bossObjective);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.objective.rejectionMessage);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId, oid]);

  const handleCheckInStatusChange = (status) => {
    setCheckinStatus(status);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleValidationNoteChange = (e) => {
    setValidatedCheckInNote(e.target.value);
  };

  const handleValidationLevelChange = (e) => {
    setValidatedCheckInLevel(e.target.value);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseAlt = () => {
    setRejectionMessage("");
    setShowAlt(false);
  };
  const handleShowAlt = () => setShowAlt(true);

  const handleShowValidation = (id, reportedLevel, reportedDate) => {
    setReportedCheckInId(id);
    setReportedCheckInLevel(reportedLevel);
    setReportedCheckInDate(reportedDate);
    setShowValidation(true);
  };

  const handleCloseValidation = () => setShowValidation(false);

  const selectStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "pending-status-label";
      case "approved":
        return "";
      case "rejected":
        return "rejected-status-label";
      default:
        return "pending-status-label";
    }
  };

  const selectStatusText = (status) => {
    switch (status) {
      case "pending":
        return "pendiente";
      case "approved":
        return "";
      case "rejected":
        return "rechazado";
      default:
        return "pendiente";
    }
  };

  const handleEvidenceChange = (e) => {
    setFile({ name: e.target.name, file: e.target.files[0] });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append(file.name, file.file);
    formData.append("checkinLevel", level);
    formData.append("checkinStatus", checkinStatus);
    formData.append("note", note);
    formData.append("id", id);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/add/checkin/update/${id}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myobjectives");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const deleteObjective = async (id) => {
    try {
      setIsLoading(true);
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myobjectives");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const approveObjective = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/update/status/${id}`,
        data: {
          status: "approved",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myobjectives", {
        state: { tabKey: "MyTeam" },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const closeObjective = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/update/status/${id}`,
        data: {
          status: "closed",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myobjectives");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const rejectObjective = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/update/status/${id}`,
        data: {
          status: "rejected",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/myobjectives", {
        state: { tabKey: "MyTeam" },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const validateObjective = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/update/status/${id}`,
        data: {
          status: "validated",
          rejectionMessage: rejectionMessage,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      navigate("/myobjectives", {
        state: { tabKey: "MyTeam" },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleDownloadEvidence = async (evidence) => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/objectives/download/file`,
      data: {
        key: evidence,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    const link = document.createElement("a");
    link.download = "evidence";

    link.target = "_blank";

    link.href = response.data.url;

    link.click();
  };

  const checkDate = () => {
    const today = new Date();
    const sevenDaysLater = today.setDate(today.getDate() + 7);
    return sevenDaysLater >= new Date(dueDate);
  };

  const validateCheckIn = async (checkInId) => {
    setIsLoading(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/update/checkin/${checkInId}`,
        data: {
          validatedLevel: validatedCheckInLevel,
          validationMessage: validatedCheckInNote,
          objectiveId: oid,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/${oid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setDescription(response.data.objective.description);
      setObjectiveUserId(response.data.objective.userId);
      setWeight(response.data.objective.weight);
      setDueDate(new Date(response.data.objective.dueDate));
      setStartDate(new Date(response.data.objective.created_at));
      setStatus(response.data.objective.status);
      setApproverId(response.data.objective.approverId);
      setId(response.data.objective._id);
      setBossObjective(response.data.bossObjective);
      setLastCheckIns(response.data.lastCheckIns);
      setRejectionMessage(response.data.objective.rejectionMessage);
      handleCloseValidation();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="justify-content-center align-items-start">
          <Col lg={6}>
            {rejectionMessage !== "" ? (
              <Col className="mb-3">
                <Alert variant="danger">{rejectionMessage}</Alert>
              </Col>
            ) : (
              <></>
            )}

            <Row className="justify-content-center align-items-center">
              <Col>
                <h5>{t("Objetivos.Detalles.Titulo")}</h5>
              </Col>
              <Col className="right">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <FontAwesomeIcon icon={faBars} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {(status === "pending" || status === "rejected") &&
                    objectiveUserId === state.userId ? (
                      <Dropdown.Item as={Link} to={`/objectives/edit/${id}`}>
                        <FontAwesomeIcon icon={faPencilAlt} />{" "}
                        {t("Objetivos.Detalles.Editar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {(status === "pending" && approverId === state.userId) ||
                    (status === "pending" && state.role === "root") ? (
                      <Dropdown.Item onClick={() => approveObjective(id)}>
                        <FontAwesomeIcon icon={faCheck} />{" "}
                        {t("Objetivos.Detalles.Aprobar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {status === "pending" && approverId === state.userId ? (
                      <Dropdown.Item onClick={() => handleShowAlt()}>
                        <FontAwesomeIcon icon={faTimes} />{" "}
                        {t("Objetivos.Detalles.Rechazar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {(status === "pending" || status === "rejected") &&
                    objectiveUserId === state.userId ? (
                      <Dropdown.Item onClick={() => handleShow()}>
                        <FontAwesomeIcon icon={faTrash} />{" "}
                        {t("Objetivos.Detalles.Eliminar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {(status === "pending" || status === "approved") &&
                    objectiveUserId === state.userId ? (
                      <Dropdown.Item
                        onClick={() => navigate(`/objectives/invite/${id}`)}
                      >
                        <FontAwesomeIcon icon={faUserPlus} />{" "}
                        {t("Objetivos.Detalles.Invitar")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {status === "approved" &&
                    objectiveUserId === state.userId ? (
                      <Dropdown.Item onClick={() => closeObjective(id)}>
                        <FontAwesomeIcon icon={faTimesCircle} />{" "}
                        {t("Objetivos.Detalles.CerrarObjetivo")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {/* {checkDate() &&
                    status === "approved" &&
                    approverId === state.userId ? (
                      <Dropdown.Item onClick={() => validateObjective(id)}>
                        <FontAwesomeIcon icon={faCheckCircle} />{" "}
                        {t("Objetivos.Detalles.ValidarCumplimiento")}
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )} */}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Col className="objective-card-details">
              <Row className="align-items-center mb-3">
                <Col>
                  <span className="weight-label">{weight}%</span>
                </Col>
                <Col className="right">
                  <span className={selectStatusClass(status)}>
                    {selectStatusText(status)}
                  </span>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col>
                  <Col className="date-container">
                    <p className="dueDate">
                      {dayjs(startDate).format("D-MMM-YYYY")}
                    </p>
                    <h6 className="dateLabel">
                      {t("Objetivos.Detalles.Inicio")}
                    </h6>
                  </Col>
                </Col>
                <Col>
                  <Col className="date-container right">
                    <p className="dueDate">
                      {dayjs(dueDate).format("D-MMM-YYYY")}
                    </p>
                    <h6 className="dateLabel">
                      {t("Objetivos.Detalles.Termino")}
                    </h6>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col className="center">
                  <p className="bossObjective">
                    {bossObjective ? bossObjective.description : "N/A"}
                  </p>
                  <FontAwesomeIcon icon={faChevronDown} className="mb-2" />
                  <p className="objectiveDescription">{description}</p>
                </Col>
              </Row>
            </Col>
            <h5>{t("Objetivos.Detalles.UltimosCheckIns")}</h5>
            {lastCheckIns.length === 0 ? (
              <Col className="last-checkin">
                <p className="no-checkins">
                  {t("Objetivos.Detalles.NoCheckIns")}
                </p>
              </Col>
            ) : (
              lastCheckIns.map((checkin) => (
                <ObjectiveCheckIn
                  key={checkin._id}
                  checkIn={checkin}
                  handleDownloadEvidence={handleDownloadEvidence}
                  handleShowValidation={handleShowValidation}
                  objectiveUserId={objectiveUserId}
                  currentUserId={state.userId}
                  approverId={approverId}
                  language={state.language}
                />
              ))
            )}
            {(state.role === "admin" && objectiveUserId !== state.userId) ||
            (state.role === "root" && objectiveUserId !== state.userId) ? (
              <Button
                className="btn btn-secondary"
                onClick={() =>
                  navigate(`/myobjectives/person/${objectiveUserId}`)
                }
              >
                {t("Objetivos.Detalles.Regresar")}
              </Button>
            ) : (
              <Button
                className="btn btn-secondary"
                onClick={() =>
                  navigate("/myobjectives", {
                    state: {
                      tabKey:
                        objectiveUserId === state.userId
                          ? "MyObjectives"
                          : "MyTeam",
                    },
                  })
                }
              >
                {t("Objetivos.Detalles.Regresar")}
              </Button>
            )}
          </Col>
          <Col lg={4}>
            <Row>
              <Col className="mt-3 mb-1">
                <h5>{t("Objetivos.Detalles.NuevoCheckIn")}</h5>
              </Col>
            </Row>

            <Col className="new-checkin-form">
              <Col className="d-grid gap-2">
                <ButtonGroup aria-label="Basic example">
                  <Button
                    className={
                      checkinStatus === "on-track"
                        ? "on-track-active"
                        : "on-track"
                    }
                    onClick={() => handleCheckInStatusChange("on-track")}
                    disabled={
                      status !== "approved" || objectiveUserId !== state.userId
                    }
                  >
                    {t("Objetivos.Detalles.EnCurso")}
                  </Button>
                  <Button
                    className={
                      checkinStatus === "cautious"
                        ? "caution-active"
                        : "caution"
                    }
                    onClick={() => handleCheckInStatusChange("cautious")}
                    disabled={
                      status !== "approved" || objectiveUserId !== state.userId
                    }
                  >
                    {t("Objetivos.Detalles.Atencion")}
                  </Button>
                  <Button
                    className={
                      checkinStatus === "at-risk" ? "at-risk-active" : "at-risk"
                    }
                    onClick={() => handleCheckInStatusChange("at-risk")}
                    disabled={
                      status !== "approved" || objectiveUserId !== state.userId
                    }
                  >
                    {t("Objetivos.Detalles.EnRiesgo")}
                  </Button>
                </ButtonGroup>
              </Col>
              <Col className="mt-3 mb-3">
                <Form.Label>
                  {t("Objetivos.Detalles.NivelAlMomento")}
                </Form.Label>
                <Row className="justify-content-center align-items-center">
                  <Col lg={11}>
                    <Form.Range
                      defaultValue={weight}
                      name="level"
                      onChange={(e) => handleLevelChange(e)}
                      value={level}
                      disabled={
                        status !== "approved" ||
                        objectiveUserId !== state.userId
                      }
                    />
                  </Col>
                  <Col lg={1}>
                    <span className="levelVal">{level}</span>
                  </Col>
                </Row>
              </Col>
              <Col className="mt-3 mb-3">
                <Form.Label>{t("Objetivos.Detalles.Nota")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  onChange={handleNoteChange}
                  value={note}
                />
              </Col>
              <Col className="mt-3 mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>{t("Objetivos.Detalles.Evidencia")}</Form.Label>
                  <Form.Control
                    type="file"
                    name="evidence"
                    onChange={(e) => handleEvidenceChange(e)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <Button
                    variant="primary"
                    disabled={
                      status !== "approved" || objectiveUserId !== state.userId
                    }
                    onClick={handleSubmit}
                  >
                    {t("Objetivos.Detalles.RegistrarCheckIn")}
                  </Button>
                </Form.Group>
              </Col>
            </Col>
          </Col>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Objetivos.Detalles.EliminarObjetivo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{t("Objetivos.Detalles.EstasSeguroEliminar")}</Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => deleteObjective(id)}>
              {t("Objetivos.Detalles.Eliminar")}
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              {t("Objetivos.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showAlt} onHide={handleCloseAlt}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Objetivos.Detalles.RechazarObjetivo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("Objetivos.Detalles.RazonRechazo")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rejectionMessage}
                onChange={(e) => setRejectionMessage(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => rejectObjective(id)}>
              {t("Objetivos.Detalles.Rechazar")}
            </Button>
            <Button variant="secondary" onClick={handleCloseAlt}>
              {t("Objetivos.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showValidation} onHide={handleCloseValidation}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Objetivos.Detalles.ValidarCheckIn")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Label>{t("Objetivos.Detalles.FechaCheckIn")}</Form.Label>
                <p className="reportedCheckInDate">
                  {dayjs(reportedCheckInDate).format("D-MMM-YYYY")}
                </p>
              </Col>
              <Col className="right">
                <Form.Label>
                  {t("Objetivos.Detalles.NivelReportado")}
                </Form.Label>
                <p className="reportedCheckInLevel">{reportedCheckInLevel}</p>
              </Col>
            </Row>
            <Col className="mt-3 mb-3">
              <Form.Label>{t("Objetivos.Detalles.NivelReal")}</Form.Label>
              <Row className="justify-content-center align-items-center">
                <Col lg={11}>
                  <Form.Range
                    defaultValue={validatedCheckInLevel}
                    name="level"
                    onChange={(e) => handleValidationLevelChange(e)}
                  />
                </Col>
                <Col lg={1}>
                  <span className="levelVal">{validatedCheckInLevel}</span>
                </Col>
              </Row>
            </Col>
            <Col>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>{t("Objetivos.Detalles.Comentarios")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={validatedCheckInNote}
                  onChange={(e) => handleValidationNoteChange(e)}
                />
              </Form.Group>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => validateCheckIn(reportedCheckInId)}
            >
              {t("Objetivos.Detalles.Validar")}
            </Button>
            <Button variant="secondary" onClick={handleCloseValidation}>
              {t("Objetivos.Detalles.Cancelar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}
export default ObjectiveDetails;
